import { useMutation } from '@tanstack/react-query';
import { useMixpanel } from 'react-mixpanel-browser';

import { refreshCachedDevice } from '@/api/devices';
import { PostUpdateGeofencePayload, PostUpdateGeofenceResponse } from '@/api/geofence/types';
import { axios } from '@/common/axios';
import { MutationConfig } from '@/common/react-query';
import { useErrorContext } from '@/context/ErrorContext';

export const postUpdateGeofence = (payload: PostUpdateGeofencePayload): Promise<PostUpdateGeofenceResponse> => {
    return axios.post('/device/update-geofence', payload);
};

type UsePostUpdateGeofenceOptions = {
    config?: MutationConfig<typeof postUpdateGeofence>;
    data?: PostUpdateGeofencePayload;
};

export const usePostUpdateGeofence = ({ config }: UsePostUpdateGeofenceOptions = {}) => {
    const { createErrorHandler } = useErrorContext();
    const mixpanel = useMixpanel();
    return useMutation({
        ...config,
        mutationFn: postUpdateGeofence,
        onSuccess: (_data, variables) => {
            refreshCachedDevice(variables.spotterId);
            mixpanel?.track('Geofence updated', {
                spotterId: variables.spotterId,
                radius: `${variables.radius} meters`,
            });
        },
        onError: createErrorHandler('update geofence'),
    });
};
